import React from 'react';
import { useBrand } from '../../contexts/BrandContext';
import { principles } from '../../data/site';
export function Values() {
  const {
    brand
  } = useBrand();
  return <section className="bg-ink text-cream" data-id="element-188" data-mp="2zofjdmi1nbf6">
      <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-24" data-id="element-189" data-mp="2zne8bi112oxg">
        <div className="grid gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-190" data-mp="2vmasuwmw6uwr">
          <div data-id="element-191" data-mp="27x9eytvairk3">
            <p className="text-[0.6875rem] uppercase tracking-label text-copper" data-id="element-192" data-mp="27wzwrsghlooy">
              People · Care · Progress · Together
            </p>
            <h2 className="mt-4 max-w-md font-serif text-3xl font-bold leading-tight md:text-5xl" data-id="element-193" data-mp="22zq320m2eqvb">
              {brand.copy.manifesto}
            </h2>
            <p className="mt-5 max-w-sm text-base leading-relaxed text-cream/70" data-id="element-194" data-mp="2bybgxigldhpr">
              Four words printed inside every box we send. They are also how we decide what to
              charge you and what to tell you.
            </p>
          </div>

          <ul className="grid gap-8 sm:grid-cols-2" data-id="element-195" data-mp="1k7f6eoi07p5n">
            {principles.map(principle => <li key={principle.name} data-id="element-196" data-mp="1cnlg4epem3uc">
                <h3 className="font-serif text-xl font-semibold text-copper" data-id="element-197" data-mp="1ho94esm906kv">{principle.name}</h3>
                <p className="mt-3 text-base leading-relaxed text-cream/70" data-id="element-198" data-mp="1mexwa91ub5kj">{principle.detail}</p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}